export const top_amenities = [
    {
        fact: "88",
        value: "21",
        icon: 'wifi'
    }, {
        fact: "22",
        value: "21",
        icon: 'local_parking'
    }, {
        fact: "96",
        value: "21",
        icon: 'breakfast_dining'
    }, {
        fact: "62",
        value: "74",
        icon: 'support_agent'
    }, {
        fact: "220",
        value: "69",
        icon: 'fitness_center'
    }, {
        fact: "43",
        value: true,
        icon: 'pool'
    }, {
        fact: "66",
        value: true,
        icon: 'room_service'
    }, {
        fact: "19",
        value: true,
        icon: 'business_center'
    }, {
        fact: "53",
        value: "3",
        icon: 'pets'
    }, {
        fact: "524",
        value: true,
        icon: 'style'
    }, {
        fact: "45",
        value: true,
        icon: 'local_laundry_service'
    }, {
        fact: "11",
        value: "21",
        icon: 'luggage'
    }, {
        fact: "131",
        value: true,
        icon: 'crib'
    }, {
        fact: "156",
        value: true,
        icon: 'local_bar'
    }, {
        fact: "170",
        value: true,
        icon: 'smoking_rooms'
    }
];